const LAYOUT = {
  MODAL_WIDTH: '560px',
  MAIN_BOX_WIDTH: '496px',
  SECTION_WIDTH: '464px',
  IMAGE_WIDTH: '424px',
  IMAGE_HEIGHT: '188px',
  ICON_SIZE: '24px'
}

const SPACING = {
  XS: '$1',
  SM: '$2',
  MD: '$3',
  LG: '$4',
  XL: '$8'
}

const BORDER_RADIUS = {
  SM: '$1',
  MD: '$2'
}

const COLORS = {
  WHITE: '$background',
  BACKGROUND_GRAY: '$backgroundSecondary',
  BORDER_LIGHT: '$medium-light-3',
  BORDER_DASHED: '$medium-light-2',
  SHADOW: '$medium-light-2',
  NO_IMAGE_BG: '$medium-light-3',
  NO_IMAGE_TEXT: '$medium-light-1'
}

const TYPOGRAPHY = {
  FONT_FAMILY: '$default',
  WEIGHT_REGULAR: '$regular',
  WEIGHT_MEDIUM: '$medium',
  SIZE_SM: '$caption',
  SIZE_MD: '$body-small',
  SIZE_LG: '$body-medium',
  LINE_HEIGHT_SM: '$tight',
  LINE_HEIGHT_MD: '$default',
  LINE_HEIGHT_LG: '$default'
}

const INFO_FIELD_DEFAULT_MARGIN_LEFT = '$4'

export { INFO_FIELD_DEFAULT_MARGIN_LEFT }

export const modalContainerStyle = {
  width: LAYOUT.MODAL_WIDTH,
  maxHeight: '90vh',
  overflow: 'auto',
  borderRadius: BORDER_RADIUS.MD,
  border: `1px solid ${COLORS.BORDER_LIGHT}`,
  boxShadow: `0px 0px ${SPACING.LG} 0px ${COLORS.SHADOW}`
}

export const modalContentStyle = {
  padding: `0 ${SPACING.XL} ${SPACING.XL} ${SPACING.XL}`,
  gap: SPACING.LG
}

export const mainBoxStyle = {
  width: LAYOUT.MAIN_BOX_WIDTH,
  height: '100%',
  borderRadius: BORDER_RADIUS.SM,
  padding: SPACING.LG,
  gap: SPACING.LG,
  background: COLORS.BACKGROUND_GRAY,
  display: 'flex',
  flexDirection: 'column'
}

export const sectionsContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: SPACING.LG
}

export const sectionBoxDefaultStyle = {
  minWidth: LAYOUT.SECTION_WIDTH,
  height: '100%',
  padding: `${SPACING.MD} ${SPACING.SM}`,
  borderRadius: BORDER_RADIUS.SM,
  gap: SPACING.MD,
  background: COLORS.WHITE,
  display: 'flex',
  flexDirection: 'column'
}

export const sectionBoxCompactStyle = {
  width: LAYOUT.SECTION_WIDTH,
  height: '100%',
  borderRadius: BORDER_RADIUS.SM,
  padding: SPACING.MD,
  gap: SPACING.SM,
  background: COLORS.WHITE,
  display: 'flex',
  flexDirection: 'column'
}

export const sectionHeaderStyle = (headerPadding) => ({
  padding: headerPadding,
  cursor: 'pointer',
  borderBottom: 'none'
})

export const sectionTitleStyle = {
  fontFamily: TYPOGRAPHY.FONT_FAMILY,
  fontWeight: TYPOGRAPHY.WEIGHT_MEDIUM,
  fontSize: TYPOGRAPHY.SIZE_LG,
  lineHeight: TYPOGRAPHY.LINE_HEIGHT_LG
}

export const chevronIconContainerStyle = (isOpen) => ({
  width: LAYOUT.ICON_SIZE,
  height: LAYOUT.ICON_SIZE,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.2s',
  color: '$actionNavigationStandardStatic'
})

export const getCollapsibleSectionStyles = (variant) =>
  variant === 'default'
    ? { sectionStyles: sectionBoxDefaultStyle, headerPadding: SPACING.MD }
    : { sectionStyles: sectionBoxCompactStyle, headerPadding: SPACING.SM }

export const fieldRowStyle = {
  gap: SPACING.XS,
  flexWrap: 'wrap'
}

export const infoFieldLabelStyle = {
  fontFamily: TYPOGRAPHY.FONT_FAMILY,
  fontWeight: TYPOGRAPHY.WEIGHT_MEDIUM
}

export const infoFieldValueStyle = {
  fontWeight: TYPOGRAPHY.WEIGHT_REGULAR
}

export const imagePreviewStyle = {
  width: LAYOUT.IMAGE_WIDTH,
  height: LAYOUT.IMAGE_HEIGHT,
  borderRadius: BORDER_RADIUS.MD
}

export const noImageBoxStyle = {
  ...imagePreviewStyle,
  backgroundColor: COLORS.NO_IMAGE_BG,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

export const noImageTextStyle = {
  color: COLORS.NO_IMAGE_TEXT,
  fontSize: TYPOGRAPHY.SIZE_MD
}

export const dateTimeContainerStyle = {
  marginLeft: '$2'
}

export const dateTimeLabelStyle = {
  fontWeight: TYPOGRAPHY.WEIGHT_MEDIUM
}

export const dateTimeValueStyle = {
  fontWeight: TYPOGRAPHY.WEIGHT_REGULAR
}

export const calendarIconStyle = {
  marginRight: SPACING.XS
}

export const clockIconStyle = {
  marginRight: SPACING.XS
}

export const eventDayTitleStyle = {
  fontFamily: TYPOGRAPHY.FONT_FAMILY,
  fontWeight: TYPOGRAPHY.WEIGHT_MEDIUM,
  fontSize: TYPOGRAPHY.SIZE_MD,
  lineHeight: TYPOGRAPHY.LINE_HEIGHT_MD
}

export const eventDayContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '$1'
}

export const eventDayLabelStyle = infoFieldLabelStyle

export const eventDayValueStyle = infoFieldValueStyle

export const dividerStyle = {
  width: '100%',
  height: '0px',
  borderTop: `1px dashed ${COLORS.BORDER_DASHED}`,
  opacity: 1,
  margin: `${SPACING.SM} 0`
}

export const buttonsContainerStyle = {
  marginTop: SPACING.LG,
  width: LAYOUT.MAIN_BOX_WIDTH
}

export const descriptionContainerStyle = {
  marginLeft: '$4'
}

export const descriptionTitleStyle = {
  fontFamily: TYPOGRAPHY.FONT_FAMILY,
  fontWeight: TYPOGRAPHY.WEIGHT_MEDIUM,
  fontSize: TYPOGRAPHY.SIZE_MD,
  lineHeight: TYPOGRAPHY.LINE_HEIGHT_MD
}

export const descriptionValueStyle = {
  textAlign: 'right',
  fontFamily: TYPOGRAPHY.FONT_FAMILY,
  fontWeight: TYPOGRAPHY.WEIGHT_REGULAR,
  fontSize: TYPOGRAPHY.SIZE_MD,
  lineHeight: TYPOGRAPHY.LINE_HEIGHT_MD
}

export const imageContainerStyle = {
  marginLeft: '$4',
  gap: SPACING.SM,
  display: 'flex',
  flexDirection: 'column'
}

export const imageTitleStyle = {
  fontFamily: TYPOGRAPHY.FONT_FAMILY,
  fontWeight: TYPOGRAPHY.WEIGHT_MEDIUM,
  fontSize: TYPOGRAPHY.SIZE_MD,
  lineHeight: TYPOGRAPHY.LINE_HEIGHT_MD
}

export const eventDaysContainerStyle = {
  padding: SPACING.MD,
  display: 'flex',
  flexDirection: 'column',
  gap: '$1'
}

export const displaySectionContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: SPACING.SM
}

export const displayFieldTitleStyle = {
  marginTop: '$2',
  marginLeft: '$4'
}

export const displayFieldValueStyle = {
  marginTop: `-${SPACING.XS}`,
  marginLeft: '$2'
}

export const disclaimerStyle = {
  marginTop: '$2',
  marginLeft: '$4'
}

export const disclaimerTextStyle = {
  fontFamily: TYPOGRAPHY.FONT_FAMILY,
  fontWeight: TYPOGRAPHY.WEIGHT_REGULAR,
  fontSize: TYPOGRAPHY.SIZE_SM,
  lineHeight: TYPOGRAPHY.LINE_HEIGHT_SM
}

export const detailsSectionContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: SPACING.MD
}
